import { required, Validator } from '@/entities/validation';
import { IssueTemplateEditable } from '@/ui/DTO';
import { validate as scoreTriggerValidator } from '@/entities/scoreTrigger';

export const validate: Validator<IssueTemplateEditable> = issueTemplate => [
  ...required(issueTemplate.title, 'title'),
  ...(scoreTriggerValidator(issueTemplate.scoreTrigger)),
];
